import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';

import CollapsibleSection from "../base/CollapsibleSection";
import CollapsibleNote from "../base/CollapsibleNote";
import ValContacts from "../base/ValContacts";
import DelRewardsCalc from "./DelRewardsCalc";
import DelWeightedRewards from "./DelWeightedRewards";
import DelHeader from './DelHeader';
import IUtils from './IUtils';
import INotes from './INotes';

import UITableUtils from "../util/UITableUtils";
import DelInline from './DelInline';
import DelNav from './DelNav';

import ApiUtils from '../util/ApiUtils';
import SPUtilities from '../util/SPUtilities';
import UIUtils from '../util/UIUtils';
import Utilities from '../util/Utilities';
import UINotes from "../util/UINotes";
import ChartUtils from "../util/ChartUtils";
import RespUtils from "../util/RespUtils";

import BaseBarChart from "../reports/BaseBarChart";
import StackedBarChart from "../reports/StackedBarChart";

class Delegate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      delegate: {},
      hermesInd: "",
      epochSummary: [],
      epochSummaryLong: [],
      events: [],
      width: window.innerWidth,
      size: 10,
      responsive: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.renderRewardsCalculations = this.renderRewardsCalculations.bind(this);
    this.renderShowMoreDetails = this.renderShowMoreDetails.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    var delegateId = IUtils.getDelegateId(this);
    // console.log("componentDidMount - after delegateId: ", delegateId);
    const allData = await ApiUtils.get("listData?type=getDelegate&delegateId=" + delegateId);
    // console.log("allData is:", allData);

    if (allData) {
      let delegate = allData["delegate"];
      let epochSummaryLong = allData["epochSummaryLong"];
      let epochSummary = allData["epochSummary"];
      // let events = allData["events"];
      this.setState({delegate: delegate, hermesInd: allData["hermesInd"],
        "epochSummary": epochSummary, "epochSummaryLong": epochSummaryLong,
        isLoading: false});

      // "events": events
    }
  }

  render() {
    // console.log("in render, pool : ", this.state.delegate);
    // console.log("in render, this.state.isLoading : ", this.state.isLoading);
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    if (this.state.delegate.delegateId === undefined) {
      return <div>Still loading</div>;
    }

    return (
      <div>
        <p/>
        <DelHeader delegate={this.state.delegate} notification={this.state.notification} desktopView={true} title="Summary"/>
        <DelInline delegate={this.state.delegate} hermesInd={this.state.hermesInd} hideNav={true}/>
        <BaseBarChart title="Epoch Production Percentage" xAxis="Epoch" yAxis="Sign Percentage"
          showVerticalLabel={true} valueAttr="prodPer" showTotalLabel={false}
          data={this.state.epochSummary} xAxisValueAttr="epochNumber"
          message="Production rate of higher than 100% means that delegate signed blocks on behalf of another delegate that was not functioning well. Missing epoch data means that delegate was not participating in consensus in that epoch. 24 delegates out of 36 elected delegates participate in consensus in every epoch. Excludes current epoch data."/>
        <hr/>
        <StackedBarChart title="Epoch Production (1 day)" xAxis="Epoch" yAxis="Signatures"
          showVerticalLabel={true} valueAttr="production" valueAttr2="missedBlocks" showTotalLabel={false}
          data={this.state.epochSummary} verticalLabel={true}  xAxisValueAttr="epochNumber" />
        <hr/>
        <StackedBarChart title="Epoch Production (30 days)" xAxis="Day" yAxis="Production"
          showVerticalLabel={true} valueAttr="production" valueAttr2="missedBlocks" showTotalLabel={false}
          data={this.state.epochSummaryLong} verticalLabel={false}  xAxisValueAttr="epochNumber" />
        <hr/>
        <CollapsibleSection getSectionContent={this.renderRewardsCalculations}
          title="Rewards Calculations" isVisible={false} sectionId="valShowMoreDetails" />
        <br/>
        <CollapsibleSection getSectionContent={this.renderShowMoreDetails}
          title="More Details" isVisible={false} sectionId="valShowMoreDetails" />
        <br/>
        <CollapsibleNote getScreenGuide={INotes.getPoolNote} />
        <DelNav delegateId={this.state.delegate.delegateId}/>
      </div>
    );
  }

  renderRewardsCalculations() {
    return (<div>
      <DelRewardsCalc delegate={this.state.delegate} />
      <DelWeightedRewards delegate={this.state.delegate} />
      </div>)
  }

  renderShowMoreDetails() {
    return (
      <Card>
        <Card.Header>More Details</Card.Header>
        <Card.Body>
          <Card.Text>
            <Table striped bordered size="sm">
                <tbody>
                  <tr>
                    <th align="left">Contact: </th>
                    <td align="left"> <ValContacts contacts={this.state.delegate.socialMedia} /></td>
                  </tr>
                  <tr>
                    <th align="left">Live Votes Delta: </th>
                    <td align="left"> {this.state.delegate.liveVotesDelta}</td>
                  </tr>
                  <tr>
                    <th align="left">Delegate ID: </th>
                    <td align="left"> {IUtils.delegateIdFormatter(this.state.delegate.id, this.state.delegate)}</td>
                  </tr>
                  <tr>
                    <th align="left">Blurb: </th>
                    <td align="left"> {this.state.delegate.blurb}</td>
                  </tr>
                  <tr>
                    <th align="left">Location: </th>
                    <td align="left"> {this.state.delegate.location}</td>
                  </tr>
                  <tr>
                    <th align="left">Introduction: </th>
                    <td align="left"> {this.state.delegate.introduction}</td>
                  </tr>
                  <tr>
                    <th align="left">Team: </th>
                    <td align="left"> {this.state.delegate.team}</td>
                  </tr>
                  <tr>
                    <th align="left">Technical Setup: </th>
                    <td align="left"> {this.state.delegate.techSetup}</td>
                  </tr>
                  <tr>
                    <th align="left">Community Plan: </th>
                    <td align="left"> {this.state.delegate.communityPlan}</td>
                  </tr>
                  <tr>
                    <th align="left">Delegate ETH Address: </th>
                    <td align="left"> {IUtils.addressFormatter(this.state.delegate.tempEthAddress)}</td>
                  </tr>
                  <tr>
                    <th align="left">Operator Address: </th>
                    <td align="left"> {IUtils.addressFormatter(this.state.delegate.operatorAddress)}</td>
                  </tr>
                  <tr>
                    <th align="left">Reward Address: </th>
                    <td align="left"> {IUtils.addressFormatter(this.state.delegate.rewardAddress)}</td>
                  </tr>
                  <tr>
                    <th align="left">Server Status: </th>
                    <td align="left"> {this.state.delegate.serverStatus}</td>
                  </tr>
                  <tr>
                    <th align="left">Server Health Endpoint: </th>
                    <td align="left"> <a href={this.state.delegate.serverHealthEndpoint}>Status</a></td>
                  </tr>
                  <tr>
                    <th align="left">Productivity Base: </th>
                    <td align="left"> {this.state.delegate.productivityBase}</td>
                  </tr>
                  <tr>
                    <th align="left">Node Version: </th>
                    <td align="left"> {this.state.delegate.nodeVersion}</td>
                  </tr>
                </tbody>
              </Table>
              <hr/>
              <p><b>Flags</b></p>
              <Table striped bordered size="sm" >
                <thead>
                  <tr>
                    <th>Hermes? (Auto Rewards)</th>
                    <th>Genesis Delegate?</th>
                    <th>Ambassador?</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="left"> {this.state.delegate.hermesInd === "1" ? "Yes" : "No"}</td>
                    <td align="left"> {this.state.delegate.genesisInd === "1" ? "Yes" : "No"}</td>
                    <td align="left"> {this.state.delegate.ambassdorInd === "1" ? "Yes" : "No"}</td>
                  </tr>
                </tbody>
              </Table>

          </Card.Text>
        </Card.Body>
      </Card>);
  }
}

export default Delegate;



// WEBPACK FOOTER //
// ./src/iotex/Delegate.js